/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_TitleInputs */

const en_privacy_section_7_title = /** @type {(inputs: Privacy_Section_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Your Rights (GDPR)`)
};

const lv_privacy_section_7_title = /** @type {(inputs: Privacy_Section_7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Jūsu tiesības (GDPR)`)
};

/**
* | output |
* | --- |
* | "7. Your Rights (GDPR)" |
*
* @param {Privacy_Section_7_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_title = /** @type {((inputs?: Privacy_Section_7_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_title(inputs)
	return en_privacy_section_7_title(inputs)
});